import type React from "react";

const LearningThemes: React.FC = () => {
	const themes = [
		{
			id: "programming",
			category: "プログラミング",
			icon: "💻",
			examples: [
				{ id: "web", text: "Web開発" },
				{ id: "app", text: "アプリ開発" },
				{ id: "data", text: "データサイエンス" },
			],
		},
		{
			id: "design",
			category: "デザイン",
			icon: "🎨",
			examples: [
				{ id: "ui", text: "UIデザイン" },
				{ id: "graphic", text: "グラフィックデザイン" },
				{ id: "illustration", text: "イラスト" },
			],
		},
		{
			id: "business",
			category: "ビジネス",
			icon: "💼",
			examples: [
				{ id: "marketing", text: "マーケティング" },
				{ id: "entrepreneur", text: "起業" },
				{ id: "project", text: "プロジェクト管理" },
			],
		},
		{
			id: "language",
			category: "語学",
			icon: "🌏",
			examples: [
				{ id: "english", text: "英語" },
				{ id: "chinese", text: "中国語" },
				{ id: "programming", text: "プログラミング言語" },
			],
		},
	];

	return (
		<section className="py-16 md:py-24 bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-12">
					<h2 className="text-3xl md:text-4xl font-bold mb-4">学習テーマ</h2>
					<p className="text-lg text-gray-600">
						あなたの興味に合わせて学習テーマを選べます
					</p>
				</div>

				<div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
					{themes.map((theme) => (
						<div
							key={theme.id}
							className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
						>
							<div className="text-4xl mb-4">{theme.icon}</div>
							<h3 className="text-xl font-semibold mb-4">{theme.category}</h3>
							<ul className="space-y-2 text-gray-600">
								{theme.examples.map((example) => (
									<li key={example.id}>• {example.text}</li>
								))}
							</ul>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default LearningThemes;
